import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Header } from './Header';
import { Footer } from './Footer';
import { useContentData } from '../hooks/useContentData';

const API_URL = process.env.REACT_APP_BACKEND_URL;

export const ProductDescriptionPage = () => {
  const { data } = useContentData();
  const [fileUrl, setFileUrl] = useState(null);
  const [fileType, setFileType] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchProductDescription();
  }, []);

  const fetchProductDescription = async () => {
    try {
      const response = await axios.get(`${API_URL}/api/settings`);
      const url = response.data.product_description_url;
      const type = response.data.product_description_type;
      
      if (!url) {
        setError('No product description available');
        setLoading(false);
        return;
      }

      setFileUrl(url);
      setFileType(type || 'image'); // Default to image if type not set
      setLoading(false);
    } catch (err) {
      console.error('Error fetching product description:', err);
      setError('Failed to load product description');
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gray-900 flex flex-col">
      <Header topnavData={data.topnav} settings={data.settings} />
      
      <main className="flex-1 pt-20 bg-gray-900">
        {loading ? (
          <div className="flex items-center justify-center h-96">
            <div className="text-white">Loading...</div>
          </div>
        ) : error ? (
          <div className="flex items-center justify-center h-96">
            <div className="text-red-400">{error}</div>
          </div>
        ) : fileType === 'pdf' ? (
          <div className="max-w-7xl mx-auto px-4 py-8">
            <img
              src={fileUrl}
              alt="Product Description"
              className="w-full h-auto"
            />
          </div>
        ) : (
          <div className="max-w-7xl mx-auto px-4 py-8">
            <img
              src={fileUrl}
              alt="Product Description"
              className="w-full h-auto"
            />
          </div>
        )}
      </main>

      <Footer footerData={data.footer} settings={data.settings} />
    </div>
  );
};
